import { HttpErrorResponse } from '@angular/common/http';

import {
  CatalogErrorReasonCode,
  CatalogErrorResponse,
} from '@services/orders/interfaces/order.interfaces';

/**
 * Maps the agreed cart codes and legacy catalog errors to customer messages.
 */
const REASON_TEXTS: Record<CatalogErrorReasonCode, string> = {
  unavailable: 'Este producto ya no está disponible',
  coming_soon: 'Este producto pasó a próximamente y todavía no se puede comprar',
  PRODUCT_NOT_FOUND: 'Este producto ya no está disponible',
  PRODUCT_INACTIVE: 'Este producto ya no está disponible',
  PRODUCT_COMING_SOON: 'Este producto pasó a próximamente y todavía no se puede comprar',
  VARIANT_NOT_FOUND: 'La opción que elegiste ya no está disponible',
  VARIANT_UNAVAILABLE: 'La opción que elegiste ya no está disponible',
  PRODUCT_WITHOUT_PRICE: 'Este producto ya no está disponible',
  INVALID_CONFIGURATION: 'La configuración de este producto ya no es válida',
};

/** El backend puede sumar códigos sin avisar: uno desconocido no debe romper. */
const FALLBACK_REASON_TEXT = 'Este producto ya no está disponible';

export const reasonTextFor = (reasonCode: string | null | undefined): string =>
  REASON_TEXTS[reasonCode as CatalogErrorReasonCode] ?? FALLBACK_REASON_TEXT;

/**
 * `POST /orders` avisa del producto caído con un 400 o un 404. Cuál de los dos
 * no importa: los dos significan lo mismo para el cliente. Lo que distingue a
 * un error de catálogo de uno genérico (DTO inválido, captcha) es que traiga
 * `reasonCode` y `productId`.
 */
export const catalogErrorFrom = (error: HttpErrorResponse): CatalogErrorResponse | null => {
  const body = error.error as Partial<CatalogErrorResponse> | null | undefined;

  if (typeof body?.reasonCode !== 'string' || typeof body?.productId !== 'string') {
    return null;
  }

  return body as CatalogErrorResponse;
};
